<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.238 7.19 6.386 2.34a1.144 1.144 0 1 0-1.625 1.613l4.051 4.051-4.051 4.052a1.144 1.144 0 0 0 0 1.613 1.143 1.143 0 0 0 .812.332 1.143 1.143 0 0 0 .813-.332l4.852-4.852a1.145 1.145 0 0 0 0-1.625Z"
      fill="currentColor"
    />
  </svg>
</template>
